import { Node } from 'tiptap';

export default class GridCard extends Node {
	get name() {
		return 'grid_card';
	}

	get schema() {
		return {
			attrs: {
				gridlink: {
					default: null
				}
			},
			content: 'card_header{1} card_content{1}',
			marks: 'link',
			toDOM: (node) => {
				return [
					'div',
					{ class: 'grid-card' },
					['a', {
						href: node.attrs.gridlink,
						class: 'grid-card__link'
					}, 0],
				]
			},
			parseDOM: [{
				tag: 'div[gridlink]',
				getAttrs: dom => ({
					gridlink: dom.getAttribute('gridlink'),
				}),
			}]
		}
	}
}